import React, { useState } from "react"
import {
  Paper,
  Typography,
  Button,
  Container,
  Grid,
  createTheme,
  TextField,
  ThemeProvider,
} from "@material-ui/core"
import { useTranslation } from "react-i18next"
import moment from "moment"
import { COLORS } from "../globalColors"
import { commonConst } from "../data/commonConst"
import useBangla from "../customhooks/useBangla"
import useMoment from "../customhooks/useMoment"
import { dateConverter } from "../utils/helperFunction"

// import useMoment from '../customhooks/useMoment';
// import moment from 'moment'

export const inlineStyles = {
  header: {
    fontSize: "24px",
    letterSpacing: "0.75px",
    color: COLORS.TEXT,
    fontWeight: "600",
  },
  paragraph: {
    fontSize: "16px",
    letterSpacing: "0.75px",
    color: COLORS.TEXT,
    fontWeight: "400",
  },
  paragraphLight: {
    fontSize: "16px",
    letterSpacing: "0.75px",
    color: COLORS.LIGHT_TEXT,
    fontWeight: "400",
  },
  alert: {
    backgroundColor: "white",
    color: COLORS.TEXT,
    fontFamily: COLORS.FONT,
    fontSize: "16px",
  },
  snackbar: {
    backgroundColor: "rgba(48, 48, 48, 0.95)",
    borderRadius: "10px",
    color: "#303030",
  },
}
export function RedColorText({ children, color, customStyles }) {
  return (
    <span
      style={{
        ...inlineStyles.paragraph,
        color: `${color || COLORS.RED_ACCENT_2}`,
        ...customStyles,
        fontWeight: "700",
      }}
    >
      {children}
    </span>
  )
}

export function ProcessTime({ time }) {
  const { t: commonLocalization } = useTranslation(["common"])
  const { isBangla, languageConst } = useBangla()
  const localizeMoment = useMoment()

  return (
    <div
      style={{
        // marginTop: "15px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: "62px",
        padding: "5px 0px ",
        border: "0.5px solid #8E8E8E",
        borderRadius: "10px",
        width: "253px",
        // width: "50%",
      }}
    >
      <Typography style={{ ...inlineStyles.paragraphLight, verticalAlign: "middle" }}>
        {commonLocalization(commonConst.PROCESS_TIME)}
        {":"}
      </Typography>
      {/* <span style={{ paddingTop: "15px", letterSpacing: ".75px" }}>

            Process Time:
        </span> */}
      <span style={{ paddingLeft: "15px" }}>
        <div
          style={{
            ...inlineStyles.paragraphLight,
            height: "22px",
            width: "96px",
            position: "relative",
            fontSize: "12px",
            textAlign: "center",
            top: "5px",
          }}
        >
          hh: mm: ss
        </div>
        <span
          style={{
            position: "relative",
            ...inlineStyles.header,
            padding: "0px",
            alignItems: "center",
            top: "-5px",
          }}
        >
          {dateConverter(localizeMoment, moment(time).subtract(6, "hours"))}
        </span>
      </span>
    </div>
  )
}
